import { createReducer } from '@reduxjs/toolkit';

import { noop } from '@constants/general';

import {
  CONVERSION_TOOL_COLUMNS_FETCH_FAILURE,
  CONVERSION_TOOL_COLUMNS_FETCH_START,
  CONVERSION_TOOL_COLUMNS_FETCH_SUCCESS,
  CONVERSION_TOOL_COLUMNS_RESET,
  CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_START,
  CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_SUCCESS,
  CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_FAILURE,
  CONVERSION_TOOL_SET_MAPPING_COLUMNS,
} from './conversionToolColumns.const';

export const initialState = {
  model: { columns: [], selectedValues: {}, mappingColumns: [] },
  meta: { hasError: false, isLoading: false, errorMessage: '' },
};

const conversionToolColumnsReducer = createReducer(initialState, builder => {
  builder
    .addCase(CONVERSION_TOOL_COLUMNS_RESET, () => initialState)
    .addCase(CONVERSION_TOOL_COLUMNS_FETCH_START, state => {
      state.meta.isLoading = true;
      state.meta.hasError = false;
    })
    .addCase(CONVERSION_TOOL_COLUMNS_FETCH_SUCCESS, (state, { payload }) => {
      state.meta.isLoading = false;
      state.model.columns = payload;
      state.meta.hasError = false;
    })
    .addCase(CONVERSION_TOOL_COLUMNS_FETCH_FAILURE, (state, { payload }) => {
      state.meta.isLoading = false;
      state.meta.hasError = true;
      state.meta.errorMessage = payload;
    })
    .addCase(CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_START, state => {
      state.meta.isLoading = true;
      state.meta.hasError = false;
    })
    .addCase(CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_SUCCESS, (state, { payload }) => {
      state.meta.isLoading = false;
      state.model.selectedValues = payload;
      state.meta.hasError = false;
    })
    .addCase(CONVERSION_TOOL_SET_MAPPING_COLUMNS, (state, { payload }) => {
      state.meta.isLoading = false;
      state.model.mappingColumns = payload;
      state.meta.hasError = false;
    })
    .addCase(CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_FAILURE, state => {
      state.meta.isLoading = false;
    })
    .addDefaultCase(noop);
});

export default conversionToolColumnsReducer;
